export const dataC = {
  "id": 346,
  "name": "Recorrido Norte Norte - Los Chiles",
  "name_es": "Recorrido Norte Norte - Los Chiles",
  "name_en": "Recorrido Norte Norte - Los Chiles",
  "explore_mode": false,
  "slug": "norte-loschiles",
  "sponsors": [],
  "guides": [],
  "active": false,
  "url": "http://localhost:3000/",
  "guide_img_id": "icono-menu-1",
  "transition_sound_id": null,
  "survey_code": "",
  "colors": [
    {
      "id": 980,
      "color": {
        "id": 1467,
        "primary": "#ffffff",
        "secondary": "#06475d"
      },
      "order": 1
    },
    {
      "id": 983,
      "color": {
        "id": 1471,
        "primary": "#06475d",
        "secondary": "#ffffff"
      },
      "order": 0
    },
    {
      "id": 979,
      "color": {
        "id": 1468,
        "primary": "#202945",
        "secondary": "#ffffff"
      },
      "order": 0
    },
    {
      "id": 984,
      "color": {
        "id": 1472,
        "primary": "#00f0a1",
        "secondary": "#202945"
      },
      "order": 1
    },
    {
      "id": 981,
      "color": {
        "id": 1469,
        "primary": "#00f0a1",
        "secondary": "#202945"
      },
      "order": 1
    },
    {
      "id": 982,
      "color": {
        "id": 1470,
        "primary": "#202945",
        "secondary": "#ffffff"
      },
      "order": 0
    }
  ],
  "call_to_action": {
    "category": "Book",
    "mobile_redirect": "",
    "redirect": "",
    "promo_text": ""
  },
  "default_waypoint": {
    "scale": "1 1 1",
    "rig_rotation": "0 0",
    "text_color": "#202945",
    "text_scale": "1 1 1",
    "text_position": "1 1 1"
  },
  "lobby_rig_rotation": {
    "x": 0,
    "y": 0
  },
  "locations": [
    {
      "default_rotation": {
        "x": "0.0",
        "y": "0.0"
      },
      "id_tour_creator": 584,
      "id": "",
      "order": 13,
      "name": "Caño Negro - Aerea 1",
      "bg_id": "01-cn-aerea1",
      "bg_type": "img",
      "has_info": false,
      "description": "",
      "page_url": "",
      "video_id": null,
      "sound_id": "viento_1_s",
      "audio_id": "loschiles-cn1",
      "waypoints": [
        {
          "id_tour_creator": 821,
          "is_premium": false,
          "use_default": true,
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 4,
            "y_angle": -360,
            "distance": 7
          },
          "scale": "1 1 1",
          "text": "Caño Negro - Aerea 2",
          "text_es": "Caño Negro - Aerea 2",
          "text_en": "Caño Negro - Aerea 2",
          "text_position": "1 1 1",
          "text_scale": "1 1 1",
          "text_color": "#202945",
          "to": 585,
          "rig_rotation": {
            "x": "(0,",
            "y": "0)"
          }
        }
      ],
      "hotspots": [
        {
          "id_tour_creator": 535,
          "has_info": false,
          "info": "",
          "info_es": "",
          "info_en": "",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 2,
            "y_angle": 26,
            "distance": 7
          },
          "title": "Cormorán Neotropical",
          "title_en": "Cormorán Neotropical",
          "title_es": "Cormorán Neotropical",
          "sound_id": null,
          "image_id": "dsc-0038",
          "icon_id": null,
          "video_url": null
        },
        {
          "id_tour_creator": 537,
          "has_info": false,
          "info": "",
          "info_es": "",
          "info_en": "",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 4,
            "y_angle": -24,
            "distance": 7
          },
          "title": "Bienteveo Común",
          "title_en": "Bienteveo Común",
          "title_es": "Bienteveo Común",
          "sound_id": null,
          "image_id": "dsc-0051",
          "icon_id": null,
          "video_url": null
        },
        {
          "id_tour_creator": 488,
          "has_info": false,
          "info": "El Refugio alberga una gran cantidad de especies en peligro de extinción y es reconocido por su diversidad de mamíferos, incluyendo peces de agua dulce propios de la zona. Es un lugar único para la observación de vida silvestre, tanto diurna, como nocturna y una experiencia inolvidable para los amantes de la naturaleza.",
          "info_es": "El Refugio alberga una gran cantidad de especies en peligro de extinción y es reconocido por su diversidad de mamíferos, incluyendo peces de agua dulce propios de la zona. Es un lugar único para la observación de vida silvestre, tanto diurna, como nocturna y una experiencia inolvidable para los amantes de la naturaleza.",
          "info_en": "El Refugio alberga una gran cantidad de especies en peligro de extinción y es reconocido por su diversidad de mamíferos, incluyendo peces de agua dulce propios de la zona. Es un lugar único para la observación de vida silvestre, tanto diurna, como nocturna y una experiencia inolvidable para los amantes de la naturaleza.",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": -13,
            "y_angle": 8,
            "distance": 7
          },
          "title": "  ",
          "title_en": "  ",
          "title_es": "  ",
          "sound_id": null,
          "image_id": "01-cn-aerea1",
          "icon_id": "informationtour",
          "video_url": null
        },
        {
          "id_tour_creator": 439,
          "has_info": false,
          "info": "Esta garza se distingue por su peculiar pico en forma de bota, que es ancho y aplanado en la base, y que le permite capturar a sus presas, compuestas por insectos, crustáceos, anfibios y pequeños peces, entre otros.El Arapapá es una garza de tamaño medio, que mide alrededor de 50 cm de largo. Su plumaje es de color marrón oscuro en la parte superior, y blanco en la parte inferior, con manchas negras en el cuello y la cabeza.",
          "info_es": "Esta garza se distingue por su peculiar pico en forma de bota, que es ancho y aplanado en la base, y que le permite capturar a sus presas, compuestas por insectos, crustáceos, anfibios y pequeños peces, entre otros.El Arapapá es una garza de tamaño medio, que mide alrededor de 50 cm de largo. Su plumaje es de color marrón oscuro en la parte superior, y blanco en la parte inferior, con manchas negras en el cuello y la cabeza.",
          "info_en": "Esta garza se distingue por su peculiar pico en forma de bota, que es ancho y aplanado en la base, y que le permite capturar a sus presas, compuestas por insectos, crustáceos, anfibios y pequeños peces, entre otros.El Arapapá es una garza de tamaño medio, que mide alrededor de 50 cm de largo. Su plumaje es de color marrón oscuro en la parte superior, y blanco en la parte inferior, con manchas negras en el cuello y la cabeza.",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": -6,
            "y_angle": 49,
            "distance": 7
          },
          "title": "Garza pico de bota",
          "title_en": "Garza pico de bota",
          "title_es": "Garza pico de bota",
          "sound_id": null,
          "image_id": "dsc-0017",
          "icon_id": null,
          "video_url": null
        }
      ],
      "trivias": [],
      "description_en": "",
      "description_es": "",
      "name_es": "Caño Negro - Aerea 1",
      "name_en": "Caño Negro - Aerea 1",
      "lines": []
    },
    {
      "default_rotation": {
        "x": "0.0",
        "y": "0.0"
      },
      "id_tour_creator": 577,
      "id": "",
      "order": 5,
      "name": "Frontera Norte",
      "bg_id": "frontera02",
      "bg_type": "img",
      "has_info": false,
      "description": "",
      "page_url": "",
      "video_id": null,
      "sound_id": "ambiente_ciudad_s",
      "audio_id": "loschiles-frontera",
      "waypoints": [
        {
          "id_tour_creator": 866,
          "is_premium": false,
          "use_default": true,
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 3,
            "y_angle": 0,
            "distance": 7
          },
          "scale": "1 1 1",
          "text": "Oficinas",
          "text_es": "Oficinas",
          "text_en": "Oficinas",
          "text_position": "1 1 1",
          "text_scale": "1 1 1",
          "text_color": "#202945",
          "to": 613,
          "rig_rotation": {
            "x": "(0,",
            "y": "0)"
          }
        }
      ],
      "hotspots": [
        {
          "id_tour_creator": 482,
          "has_info": false,
          "info": "El Puesto Fronterizo Las Tablillas es uno de los puntos de entrada y salida más importantes del país, ya que su ubicación geográfica lo convierte en un punto estratégico para el tránsito de personas, mercancías y vehículos entre Costa Rica y Nicaragua. Como Aduana, cumple con una función fundamental en la regulación de estos intercambios, garantizando la seguridad y eficiencia en los servicios que ofrece.",
          "info_es": "El Puesto Fronterizo Las Tablillas es uno de los puntos de entrada y salida más importantes del país, ya que su ubicación geográfica lo convierte en un punto estratégico para el tránsito de personas, mercancías y vehículos entre Costa Rica y Nicaragua. Como Aduana, cumple con una función fundamental en la regulación de estos intercambios, garantizando la seguridad y eficiencia en los servicios que ofrece.",
          "info_en": "El Puesto Fronterizo Las Tablillas es uno de los puntos de entrada y salida más importantes del país, ya que su ubicación geográfica lo convierte en un punto estratégico para el tránsito de personas, mercancías y vehículos entre Costa Rica y Nicaragua. Como Aduana, cumple con una función fundamental en la regulación de estos intercambios, garantizando la seguridad y eficiencia en los servicios que ofrece.",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 9,
            "y_angle": -26,
            "distance": 7
          },
          "title": "  ",
          "title_en": "  ",
          "title_es": "  ",
          "sound_id": null,
          "image_id": "frontera02",
          "icon_id": "informationtour",
          "video_url": null
        }
      ],
      "trivias": [],
      "description_en": "",
      "description_es": "",
      "name_es": "Frontera Norte",
      "name_en": "Frontera Norte",
      "lines": []
    },
    {
      "default_rotation": {
        "x": "0.0",
        "y": "0.0"
      },
      "id_tour_creator": 582,
      "id": "",
      "order": 12,
      "name": "Caño Negro - La Torre",
      "bg_id": "la-torre-cn",
      "bg_type": "img",
      "has_info": false,
      "description": "",
      "page_url": "",
      "video_id": null,
      "sound_id": "viento_1_s",
      "audio_id": "loschiles-torre",
      "waypoints": [
        {
          "id_tour_creator": 823,
          "is_premium": false,
          "use_default": true,
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 10,
            "y_angle": -4,
            "distance": 5
          },
          "scale": "1 1 1",
          "text": "Caño Negro - Aerea 1",
          "text_es": "Caño Negro - Aerea 1",
          "text_en": "Caño Negro - Aerea 1",
          "text_position": "1 1 1",
          "text_scale": "1 1 1",
          "text_color": "#202945",
          "to": 584,
          "rig_rotation": {
            "x": "(0,",
            "y": "0)"
          }
        }
      ],
      "hotspots": [
        {
          "id_tour_creator": 442,
          "has_info": false,
          "info": "",
          "info_es": "",
          "info_en": "",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": -8,
            "y_angle": -35,
            "distance": 7
          },
          "title": "Cocodrilo",
          "title_en": "Cocodrilo",
          "title_es": "Cocodrilo",
          "sound_id": null,
          "image_id": "dsc-9684",
          "icon_id": null,
          "video_url": null
        },
        {
          "id_tour_creator": 441,
          "has_info": false,
          "info": "",
          "info_es": "",
          "info_en": "",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": -1,
            "y_angle": 38,
            "distance": 7
          },
          "title": "Tántalo Americano",
          "title_en": "Tántalo Americano",
          "title_es": "Tántalo Americano",
          "sound_id": null,
          "image_id": "dsc-0111",
          "icon_id": null,
          "video_url": null
        },
        {
          "id_tour_creator": 487,
          "has_info": false,
          "info": "La Torre de Observación es un mirador impresionante que se eleva a 18 metros de altura, con varios niveles diseñados para la observación y fotografía. Esta atracción turística ofrece a los visitantes una oportunidad única para conocer las más de 400 especies de aves que habitan en el Refugio Nacional de Vida Silvestre Mixto Caño Negro. Desde esta perspectiva privilegiada, los turistas pueden admirar la belleza y diversidad de la fauna silvestre que convive en este paraíso natural.\n",
          "info_es": "La Torre de Observación es un mirador impresionante que se eleva a 18 metros de altura, con varios niveles diseñados para la observación y fotografía. Esta atracción turística ofrece a los visitantes una oportunidad única para conocer las más de 400 especies de aves que habitan en el Refugio Nacional de Vida Silvestre Mixto Caño Negro. Desde esta perspectiva privilegiada, los turistas pueden admirar la belleza y diversidad de la fauna silvestre que convive en este paraíso natural.\n",
          "info_en": "La Torre de Observación es un mirador impresionante que se eleva a 18 metros de altura, con varios niveles diseñados para la observación y fotografía. Esta atracción turística ofrece a los visitantes una oportunidad única para conocer las más de 400 especies de aves que habitan en el Refugio Nacional de Vida Silvestre Mixto Caño Negro. Desde esta perspectiva privilegiada, los turistas pueden admirar la belleza y diversidad de la fauna silvestre que convive en este paraíso natural.\n",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 7,
            "y_angle": 63,
            "distance": 7
          },
          "title": "  ",
          "title_en": "  ",
          "title_es": "  ",
          "sound_id": null,
          "image_id": "la-torre-cn",
          "icon_id": "informationtour",
          "video_url": null
        }
      ],
      "trivias": [],
      "description_en": "",
      "description_es": "",
      "name_es": "Caño Negro - La Torre",
      "name_en": "Caño Negro - La Torre",
      "lines": []
    },
    {
      "default_rotation": {
        "x": "0.0",
        "y": "0.0"
      },
      "id_tour_creator": 586,
      "id": "",
      "order": 15,
      "name": "Caño Negro - Aerea 3",
      "bg_id": "pueblo-cn",
      "bg_type": "img",
      "has_info": false,
      "description": "",
      "page_url": "",
      "video_id": null,
      "sound_id": "ambiente_ciudad_s",
      "audio_id": null,
      "waypoints": [
        {
          "id_tour_creator": 818,
          "is_premium": false,
          "use_default": true,
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": -5,
            "y_angle": 0,
            "distance": 5
          },
          "scale": "1 1 1",
          "text": "Caño Negro - Aerea 4",
          "text_es": "Caño Negro - Aerea 4",
          "text_en": "Caño Negro - Aerea 4",
          "text_position": "1 1 1",
          "text_scale": "1 1 1",
          "text_color": "#202945",
          "to": 587,
          "rig_rotation": {
            "x": "(0,",
            "y": "0)"
          }
        }
      ],
      "hotspots": [],
      "trivias": [],
      "description_en": "",
      "description_es": "",
      "name_es": "Caño Negro - Aerea 3",
      "name_en": "Caño Negro - Aerea 3",
      "lines": []
    },
    {
      "default_rotation": {
        "x": "0.0",
        "y": "0.0"
      },
      "id_tour_creator": 585,
      "id": "",
      "order": 14,
      "name": "Caño Negro - Aerea 2",
      "bg_id": "02-cn-aerea",
      "bg_type": "img",
      "has_info": false,
      "description": "",
      "page_url": "",
      "video_id": null,
      "sound_id": "viento_1_s",
      "audio_id": "loschiles-cn2",
      "waypoints": [
        {
          "id_tour_creator": 820,
          "is_premium": false,
          "use_default": true,
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 1,
            "y_angle": -3,
            "distance": 7
          },
          "scale": "1 1 1",
          "text": "Caño Negro Aerea 3",
          "text_es": "Caño Negro Aerea 3",
          "text_en": "Caño Negro Aerea 3",
          "text_position": "1 1 1",
          "text_scale": "1 1 1",
          "text_color": "#202945",
          "to": 586,
          "rig_rotation": {
            "x": "(0,",
            "y": "0)"
          }
        }
      ],
      "hotspots": [
        {
          "id_tour_creator": 533,
          "has_info": false,
          "info": "",
          "info_es": "",
          "info_en": "",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 15,
            "y_angle": 5,
            "distance": 7
          },
          "title": "Garza Tigre",
          "title_en": "Garza Tigre",
          "title_es": "Garza Tigre",
          "sound_id": null,
          "image_id": "dsc-9843",
          "icon_id": null,
          "video_url": null
        },
        {
          "id_tour_creator": 489,
          "has_info": false,
          "info": "Para los Maleku es la Morada de los Dioses, lugar donde se puede ir a comunicar con los ancestros Maleku, con Lhafara (Diosa Maleku), lugar muy especial para la subsistencia Malecu en donde se reviven los recuerdos con los familiares que ya no están.",
          "info_es": "Para los Maleku es la Morada de los Dioses, lugar donde se puede ir a comunicar con los ancestros Maleku, con Lhafara (Diosa Maleku), lugar muy especial para la subsistencia Malecu en donde se reviven los recuerdos con los familiares que ya no están.",
          "info_en": "Para los Maleku es la Morada de los Dioses, lugar donde se puede ir a comunicar con los ancestros Maleku, con Lhafara (Diosa Maleku), lugar muy especial para la subsistencia Malecu en donde se reviven los recuerdos con los familiares que ya no están.",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 3,
            "y_angle": 19,
            "distance": 7
          },
          "title": "  ",
          "title_en": "  ",
          "title_es": "  ",
          "sound_id": null,
          "image_id": "02-cn-aerea",
          "icon_id": "informationtour",
          "video_url": null
        },
        {
          "id_tour_creator": 534,
          "has_info": false,
          "info": "",
          "info_es": "",
          "info_en": "",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 20,
            "y_angle": -15,
            "distance": 7
          },
          "title": "Tirano Melancólico",
          "title_en": "Tirano Melancólico",
          "title_es": "Tirano Melancólico",
          "sound_id": null,
          "image_id": "dsc-9887",
          "icon_id": null,
          "video_url": null
        },
        {
          "id_tour_creator": 494,
          "has_info": false,
          "info": "El Anhinga se caracteriza por su cuello y cola de gran longitud, lo que le permite sumergirse en el agua en busca de peces y otros animales acuáticos. Cuando está posado sobre una rama u otro objeto que se extiende sobre el agua, a menudo extiende sus alas para secarse al sol.\n\nA pesar de su apariencia de serpiente, el Anhinga es un ave emparentada con las garzas y las cigüeñas. A diferencia de estas, no tiene un aceite especial en las plumas que lo haga impermeable al agua, por lo que después de bucear y cazar, tiene que secar sus alas antes de volar.\n",
          "info_es": "El Anhinga se caracteriza por su cuello y cola de gran longitud, lo que le permite sumergirse en el agua en busca de peces y otros animales acuáticos. Cuando está posado sobre una rama u otro objeto que se extiende sobre el agua, a menudo extiende sus alas para secarse al sol.\n\nA pesar de su apariencia de serpiente, el Anhinga es un ave emparentada con las garzas y las cigüeñas. A diferencia de estas, no tiene un aceite especial en las plumas que lo haga impermeable al agua, por lo que después de bucear y cazar, tiene que secar sus alas antes de volar.\n",
          "info_en": "El Anhinga se caracteriza por su cuello y cola de gran longitud, lo que le permite sumergirse en el agua en busca de peces y otros animales acuáticos. Cuando está posado sobre una rama u otro objeto que se extiende sobre el agua, a menudo extiende sus alas para secarse al sol.\n\nA pesar de su apariencia de serpiente, el Anhinga es un ave emparentada con las garzas y las cigüeñas. A diferencia de estas, no tiene un aceite especial en las plumas que lo haga impermeable al agua, por lo que después de bucear y cazar, tiene que secar sus alas antes de volar.\n",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 1,
            "y_angle": -44,
            "distance": 7
          },
          "title": "Pájaro Anhinga Americana-Anhinga anhinga",
          "title_en": "Pájaro Anhinga Americana-Anhinga anhinga",
          "title_es": "Pájaro Anhinga Americana-Anhinga anhinga",
          "sound_id": null,
          "image_id": "dsc-9659",
          "icon_id": null,
          "video_url": null
        }
      ],
      "trivias": [],
      "description_en": "",
      "description_es": "",
      "name_es": "Caño Negro - Aerea 2",
      "name_en": "Caño Negro - Aerea 2",
      "lines": []
    },
    {
      "default_rotation": {
        "x": "0.0",
        "y": "0.0"
      },
      "id_tour_creator": 611,
      "id": "",
      "order": 3,
      "name": "Zona Portuaria de Los Chiles",
      "bg_id": "muni-b",
      "bg_type": "img",
      "has_info": false,
      "description": "",
      "page_url": "",
      "video_id": null,
      "sound_id": "ambiente_ciudad_s",
      "audio_id": "24539914-1681501971",
      "waypoints": [
        {
          "id_tour_creator": 865,
          "is_premium": false,
          "use_default": true,
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 1,
            "y_angle": 0,
            "distance": 7
          },
          "scale": "1 1 1",
          "text": "Hacia la frontera",
          "text_es": "Hacia la frontera",
          "text_en": "Hacia la frontera",
          "text_position": "1 1 1",
          "text_scale": "1 1 1",
          "text_color": "#202945",
          "to": 576,
          "rig_rotation": {
            "x": "(0,",
            "y": "0)"
          }
        }
      ],
      "hotspots": [
        {
          "id_tour_creator": 481,
          "has_info": false,
          "info": "La zona portuaria, controlada por la municipalidad, es responsable de la salida de embarcaciones y personas por el Río Frío, un importante medio de transporte para los visitantes y turistas. Además, Los Chiles cuenta con otros servicios básicos importantes como bancos, cajeros automáticos, estaciones de gasolina, talleres de mecánica rápida y supermercados, e incluso un moderno hospital en el centro de la ciudad que garantiza la salud y el bienestar de la comunidad, lo que hace que el cantón sea un lugar conveniente y atractivo para vivir y visitar.",
          "info_es": "La zona portuaria, controlada por la municipalidad, es responsable de la salida de embarcaciones y personas por el Río Frío, un importante medio de transporte para los visitantes y turistas. Además, Los Chiles cuenta con otros servicios básicos importantes como bancos, cajeros automáticos, estaciones de gasolina, talleres de mecánica rápida y supermercados, e incluso un moderno hospital en el centro de la ciudad que garantiza la salud y el bienestar de la comunidad, lo que hace que el cantón sea un lugar conveniente y atractivo para vivir y visitar.",
          "info_en": "La zona portuaria, controlada por la municipalidad, es responsable de la salida de embarcaciones y personas por el Río Frío, un importante medio de transporte para los visitantes y turistas. Además, Los Chiles cuenta con otros servicios básicos importantes como bancos, cajeros automáticos, estaciones de gasolina, talleres de mecánica rápida y supermercados, e incluso un moderno hospital en el centro de la ciudad que garantiza la salud y el bienestar de la comunidad, lo que hace que el cantón sea un lugar conveniente y atractivo para vivir y visitar.",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 6,
            "y_angle": 39,
            "distance": 7
          },
          "title": "  ",
          "title_en": "  ",
          "title_es": "  ",
          "sound_id": null,
          "image_id": "antigua-oficina-limitrofe001",
          "icon_id": "informationtour",
          "video_url": null
        }
      ],
      "trivias": [],
      "description_en": "",
      "description_es": "",
      "name_es": "Zona Portuaria de Los Chiles",
      "name_en": "Zona Portuaria de Los Chiles",
      "lines": []
    },
    {
      "default_rotation": {
        "x": "0.0",
        "y": "0.0"
      },
      "id_tour_creator": 613,
      "id": "",
      "order": 6,
      "name": "Oficina de la Frontera Norte",
      "bg_id": "oficinaf",
      "bg_type": "img",
      "has_info": false,
      "description": "",
      "page_url": "",
      "video_id": null,
      "sound_id": "ambiente_oficina_s",
      "audio_id": "loschiles-oficinas",
      "waypoints": [
        {
          "id_tour_creator": 867,
          "is_premium": false,
          "use_default": true,
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 5,
            "y_angle": -120,
            "distance": 7
          },
          "scale": "1 1 1",
          "text": "Fotografía aérea",
          "text_es": "Fotografía aérea",
          "text_en": "Fotografía aérea",
          "text_position": "1 1 1",
          "text_scale": "1 1 1",
          "text_color": "#202945",
          "to": 578,
          "rig_rotation": {
            "x": "(0,",
            "y": "0)"
          }
        }
      ],
      "hotspots": [
        {
          "id_tour_creator": 483,
          "has_info": false,
          "info": "La presencia de este puesto aduanal no solo beneficia al sector comercial, sino también al turismo binacional, ya que facilita la movilidad de visitantes y turistas que desean conocer y disfrutar de la región. Se espera que la presencia de este puesto aduanal fomente y estimule el desarrollo del turismo en la zona, contribuyendo así al crecimiento económico y social de la comunidad.",
          "info_es": "La presencia de este puesto aduanal no solo beneficia al sector comercial, sino también al turismo binacional, ya que facilita la movilidad de visitantes y turistas que desean conocer y disfrutar de la región. Se espera que la presencia de este puesto aduanal fomente y estimule el desarrollo del turismo en la zona, contribuyendo así al crecimiento económico y social de la comunidad.",
          "info_en": "La presencia de este puesto aduanal no solo beneficia al sector comercial, sino también al turismo binacional, ya que facilita la movilidad de visitantes y turistas que desean conocer y disfrutar de la región. Se espera que la presencia de este puesto aduanal fomente y estimule el desarrollo del turismo en la zona, contribuyendo así al crecimiento económico y social de la comunidad.",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 5,
            "y_angle": -92,
            "distance": 7
          },
          "title": "  ",
          "title_en": "  ",
          "title_es": "  ",
          "sound_id": null,
          "image_id": "ofi-limitrofe2",
          "icon_id": "informationtour",
          "video_url": null
        }
      ],
      "trivias": [],
      "description_en": "",
      "description_es": "",
      "name_es": "Oficina de la Frontera Norte",
      "name_en": "Oficina de la Frontera Norte",
      "lines": []
    },
    {
      "default_rotation": {
        "x": "0.0",
        "y": "0.0"
      },
      "id_tour_creator": 579,
      "id": "",
      "order": 8,
      "name": "Humedales Medio Queso",
      "bg_id": "img-20221108-152530-00-merged-panoramafinal",
      "bg_type": "img",
      "has_info": false,
      "description": "",
      "page_url": "",
      "video_id": null,
      "sound_id": "rio_1_s",
      "audio_id": "loschiles-humedales",
      "waypoints": [
        {
          "id_tour_creator": 868,
          "is_premium": false,
          "use_default": true,
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 4,
            "y_angle": -1,
            "distance": 7
          },
          "scale": "1 1 1",
          "text": "Viajando por el humedal",
          "text_es": "Viajando por el humedal",
          "text_en": "Viajando por el humedal",
          "text_position": "1 1 1",
          "text_scale": "1 1 1",
          "text_color": "#202945",
          "to": 614,
          "rig_rotation": {
            "x": "(0,",
            "y": "0)"
          }
        }
      ],
      "hotspots": [
        {
          "id_tour_creator": 437,
          "has_info": false,
          "info": "",
          "info_es": "",
          "info_en": "",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": -1,
            "y_angle": 73,
            "distance": 7
          },
          "title": "Comorán Grande",
          "title_en": "Comorán Grande",
          "title_es": "Comorán Grande",
          "sound_id": null,
          "image_id": "dsc-9475",
          "icon_id": null,
          "video_url": null
        },
        {
          "id_tour_creator": 436,
          "has_info": false,
          "info": "",
          "info_es": "",
          "info_en": "",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 2,
            "y_angle": 41,
            "distance": 7
          },
          "title": "Pájaro Golondrina Manglera",
          "title_en": "Pájaro Golondrina Manglera",
          "title_es": "Pájaro Golondrina Manglera",
          "sound_id": null,
          "image_id": "dsc-9550",
          "icon_id": null,
          "video_url": null
        },
        {
          "id_tour_creator": 438,
          "has_info": false,
          "info": "",
          "info_es": "",
          "info_en": "",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 34,
            "y_angle": 3,
            "distance": 7
          },
          "title": "La Luna",
          "title_en": "La Luna",
          "title_es": "La Luna",
          "sound_id": null,
          "image_id": "dsc-9606",
          "icon_id": null,
          "video_url": null
        },
        {
          "id_tour_creator": 530,
          "has_info": false,
          "info": "",
          "info_es": "",
          "info_en": "",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 4,
            "y_angle": -55,
            "distance": 7
          },
          "title": "Para viajar por los humedales",
          "title_en": "Para viajar por los humedales",
          "title_es": "Para viajar por los humedales",
          "sound_id": null,
          "image_id": null,
          "icon_id": "videoicon",
          "video_url": "https://www.youtube.com/watch?v=Zz40q2aDMz4&feature=youtu.be"
        },
        {
          "id_tour_creator": 484,
          "has_info": false,
          "info": "Los Humedales de Río Medio Queso en Los Chiles son un tesoro natural de la Región Huetar Norte. Este humedal de turbera, con una extensión de 5,000 hectáreas, es uno de los pocos que existen en el país y destaca no solo por su belleza visual, sino también por su gran valor ecológico.\nEn este santuario natural, se puede apreciar una amplia variedad de especies animales como anfibios, reptiles, aves endémicas y migratorias, mamíferos y peces, lo que lo convierte en un lugar especial y único. Además, los Humedales de Río Medio Queso ofrecen múltiples actividades como observación de aves, fotografía de paisajes y atardeceres, pesca artesanal y deportiva, e investigación científica.\nGracias a estas cualidades, los Humedales de Río Medio Queso son un atractivo turístico de alto nivel en el país, con un enorme potencial para el turismo ecológico y la conservación de la naturaleza.",
          "info_es": "Los Humedales de Río Medio Queso en Los Chiles son un tesoro natural de la Región Huetar Norte. Este humedal de turbera, con una extensión de 5,000 hectáreas, es uno de los pocos que existen en el país y destaca no solo por su belleza visual, sino también por su gran valor ecológico.\nEn este santuario natural, se puede apreciar una amplia variedad de especies animales como anfibios, reptiles, aves endémicas y migratorias, mamíferos y peces, lo que lo convierte en un lugar especial y único. Además, los Humedales de Río Medio Queso ofrecen múltiples actividades como observación de aves, fotografía de paisajes y atardeceres, pesca artesanal y deportiva, e investigación científica.\nGracias a estas cualidades, los Humedales de Río Medio Queso son un atractivo turístico de alto nivel en el país, con un enorme potencial para el turismo ecológico y la conservación de la naturaleza.",
          "info_en": "Los Humedales de Río Medio Queso en Los Chiles son un tesoro natural de la Región Huetar Norte. Este humedal de turbera, con una extensión de 5,000 hectáreas, es uno de los pocos que existen en el país y destaca no solo por su belleza visual, sino también por su gran valor ecológico.\nEn este santuario natural, se puede apreciar una amplia variedad de especies animales como anfibios, reptiles, aves endémicas y migratorias, mamíferos y peces, lo que lo convierte en un lugar especial y único. Además, los Humedales de Río Medio Queso ofrecen múltiples actividades como observación de aves, fotografía de paisajes y atardeceres, pesca artesanal y deportiva, e investigación científica.\nGracias a estas cualidades, los Humedales de Río Medio Queso son un atractivo turístico de alto nivel en el país, con un enorme potencial para el turismo ecológico y la conservación de la naturaleza.",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 7,
            "y_angle": -30,
            "distance": 7
          },
          "title": "  ",
          "title_en": "  ",
          "title_es": "  ",
          "sound_id": null,
          "image_id": "humedales-mq",
          "icon_id": "informationtour",
          "video_url": null
        }
      ],
      "trivias": [],
      "description_en": "",
      "description_es": "",
      "name_es": "Humedales Medio Queso",
      "name_en": "Humedales Medio Queso",
      "lines": []
    },
    {
      "default_rotation": {
        "x": "0.0",
        "y": "0.0"
      },
      "id_tour_creator": 574,
      "id": "",
      "order": 0,
      "name": "Rio Frio",
      "bg_id": "riofrio3",
      "bg_type": "img",
      "has_info": false,
      "description": "",
      "page_url": "",
      "video_id": null,
      "sound_id": "rio_1_s",
      "audio_id": "loschiles-riof",
      "waypoints": [
        {
          "id_tour_creator": 840,
          "is_premium": false,
          "use_default": true,
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": -8,
            "y_angle": -1440,
            "distance": 7
          },
          "scale": "1 1 1",
          "text": "Muelle",
          "text_es": "Muelle",
          "text_en": "Muelle",
          "text_position": "1 1 1",
          "text_scale": "1 1 1",
          "text_color": "#202945",
          "to": 575,
          "rig_rotation": {
            "x": "(0,",
            "y": "0)"
          }
        }
      ],
      "hotspots": [
        {
          "id_tour_creator": 433,
          "has_info": false,
          "info": "Esta es la base de una vasija volcada encontrada en el río Medio Queso, Los Chiles. La vasija fue descubierta durante una excavación en la zona y se comprobó que formaba parte de una colección mayor de materiales arqueológicos. Fue descubierto por un agricultor local, que había estado excavando en busca de un tesoro enterrado.\n",
          "info_es": "Esta es la base de una vasija volcada encontrada en el río Medio Queso, Los Chiles. La vasija fue descubierta durante una excavación en la zona y se comprobó que formaba parte de una colección mayor de materiales arqueológicos. Fue descubierto por un agricultor local, que había estado excavando en busca de un tesoro enterrado.\n",
          "info_en": "Esta es la base de una vasija volcada encontrada en el río Medio Queso, Los Chiles. La vasija fue descubierta durante una excavación en la zona y se comprobó que formaba parte de una colección mayor de materiales arqueológicos. Fue descubierto por un agricultor local, que había estado excavando en busca de un tesoro enterrado.\n",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": -1,
            "y_angle": 31,
            "distance": 7
          },
          "title": "El Mojón",
          "title_en": "El Mojón",
          "title_es": "El Mojón",
          "sound_id": null,
          "image_id": "dsc-0219",
          "icon_id": null,
          "video_url": null
        },
        {
          "id_tour_creator": 434,
          "has_info": false,
          "info": "El safari en barco se encuentra en los humedales del Río Frío, situados en la región del Caribe Sur de Costa Rica. El río es un gran lugar para ver un montón de aves, monos y diferentes tipos de vida silvestre.\n",
          "info_es": "El safari en barco se encuentra en los humedales del Río Frío, situados en la región del Caribe Sur de Costa Rica. El río es un gran lugar para ver un montón de aves, monos y diferentes tipos de vida silvestre.\n",
          "info_en": "El safari en barco se encuentra en los humedales del Río Frío, situados en la región del Caribe Sur de Costa Rica. El río es un gran lugar para ver un montón de aves, monos y diferentes tipos de vida silvestre.\n",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": -4,
            "y_angle": 67,
            "distance": 7
          },
          "title": "Barco",
          "title_en": "Barco",
          "title_es": "Barco",
          "sound_id": null,
          "image_id": "dsc-9394",
          "icon_id": null,
          "video_url": null
        },
        {
          "id_tour_creator": 478,
          "has_info": false,
          "info": "El río que cruza el norte de Costa Rica y desemboca en la unión con el Río San Juan en el Lago Cocibolca en Nicaragua, tiene su origen en las faldas del Parque Nacional Volcán Tenorio. A lo largo de un recorrido de 70 kilómetros por las llanuras de los Guatusos en la provincia de Alajuela, este río forma un Corredor Biológico con una amplia biodiversidad. Este Corredor Biológico conecta dos Refugios Nacionales y sitios RAMSAR de categoría internacional: el Refugio Nacional de Vida Silvestre Mixto de Caño Negro en Costa Rica y el Refugio Nacional de Vida Silvestre de Los Guatusos en Nicaragua.",
          "info_es": "El río que cruza el norte de Costa Rica y desemboca en la unión con el Río San Juan en el Lago Cocibolca en Nicaragua, tiene su origen en las faldas del Parque Nacional Volcán Tenorio. A lo largo de un recorrido de 70 kilómetros por las llanuras de los Guatusos en la provincia de Alajuela, este río forma un Corredor Biológico con una amplia biodiversidad. Este Corredor Biológico conecta dos Refugios Nacionales y sitios RAMSAR de categoría internacional: el Refugio Nacional de Vida Silvestre Mixto de Caño Negro en Costa Rica y el Refugio Nacional de Vida Silvestre de Los Guatusos en Nicaragua.",
          "info_en": "El río que cruza el norte de Costa Rica y desemboca en la unión con el Río San Juan en el Lago Cocibolca en Nicaragua, tiene su origen en las faldas del Parque Nacional Volcán Tenorio. A lo largo de un recorrido de 70 kilómetros por las llanuras de los Guatusos en la provincia de Alajuela, este río forma un Corredor Biológico con una amplia biodiversidad. Este Corredor Biológico conecta dos Refugios Nacionales y sitios RAMSAR de categoría internacional: el Refugio Nacional de Vida Silvestre Mixto de Caño Negro en Costa Rica y el Refugio Nacional de Vida Silvestre de Los Guatusos en Nicaragua.",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 8,
            "y_angle": 12,
            "distance": 7
          },
          "title": "  ",
          "title_en": "  ",
          "title_es": "  ",
          "sound_id": null,
          "image_id": "riofrio3",
          "icon_id": "informationtour",
          "video_url": null
        },
        {
          "id_tour_creator": 536,
          "has_info": false,
          "info": "",
          "info_es": "",
          "info_en": "",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 11,
            "y_angle": 50,
            "distance": 7
          },
          "title": "Hibiscus",
          "title_en": "Hibiscus",
          "title_es": "Hibiscus",
          "sound_id": null,
          "image_id": "dsc-9436",
          "icon_id": null,
          "video_url": null
        }
      ],
      "trivias": [],
      "description_en": "",
      "description_es": "",
      "name_es": "Rio Frio",
      "name_en": "Rio Frio",
      "lines": []
    },
    {
      "default_rotation": {
        "x": "0.0",
        "y": "0.0"
      },
      "id_tour_creator": 576,
      "id": "",
      "order": 4,
      "name": "Ruta Muelle-Tablillas",
      "bg_id": "rutamt",
      "bg_type": "img",
      "has_info": false,
      "description": "",
      "page_url": "",
      "video_id": null,
      "sound_id": "viento_1_s",
      "audio_id": "new-rutamt",
      "waypoints": [
        {
          "id_tour_creator": 836,
          "is_premium": false,
          "use_default": true,
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 3,
            "y_angle": -8,
            "distance": 7
          },
          "scale": "1 1 1",
          "text": "Frontera Norte",
          "text_es": "Frontera Norte",
          "text_en": "Frontera Norte",
          "text_position": "1 1 1",
          "text_scale": "1 1 1",
          "text_color": "#202945",
          "to": 577,
          "rig_rotation": {
            "x": "(0,",
            "y": "0)"
          }
        }
      ],
      "hotspots": [
        {
          "id_tour_creator": 490,
          "has_info": false,
          "info": "La Ruta Nacional 35, que conecta la ciudad de Los Chiles con el Puesto Fronterizo en Las Tablillas, es un trayecto de 6,2 km que tiene un gran significado para la población, ya que Los Chiles siempre ha sido reconocida como una ciudad fronteriza. Además, esta ruta es la puerta de entrada a Centroamérica, esencial para garantizar el tránsito de personas, mercancías y vehículos entre Costa Rica y Nicaragua.\nLa Ruta Nacional 35 se conecta con la Ruta Nacional 32 a través del \"Tapón de Chilamate\", que es la vía principal de entrada y salida de productos de Nicaragua a través de puertos en el Caribe costarricense. También es la ruta turística que une el tránsito de visitantes entre la zona norte y la región del Caribe. Por lo tanto, esta ruta tiene un papel fundamental en el desarrollo económico y turístico de la región, y es un importante punto de conexión para los países de la región centroamericana.",
          "info_es": "La Ruta Nacional 35, que conecta la ciudad de Los Chiles con el Puesto Fronterizo en Las Tablillas, es un trayecto de 6,2 km que tiene un gran significado para la población, ya que Los Chiles siempre ha sido reconocida como una ciudad fronteriza. Además, esta ruta es la puerta de entrada a Centroamérica, esencial para garantizar el tránsito de personas, mercancías y vehículos entre Costa Rica y Nicaragua.\nLa Ruta Nacional 35 se conecta con la Ruta Nacional 32 a través del \"Tapón de Chilamate\", que es la vía principal de entrada y salida de productos de Nicaragua a través de puertos en el Caribe costarricense. También es la ruta turística que une el tránsito de visitantes entre la zona norte y la región del Caribe. Por lo tanto, esta ruta tiene un papel fundamental en el desarrollo económico y turístico de la región, y es un importante punto de conexión para los países de la región centroamericana.",
          "info_en": "La Ruta Nacional 35, que conecta la ciudad de Los Chiles con el Puesto Fronterizo en Las Tablillas, es un trayecto de 6,2 km que tiene un gran significado para la población, ya que Los Chiles siempre ha sido reconocida como una ciudad fronteriza. Además, esta ruta es la puerta de entrada a Centroamérica, esencial para garantizar el tránsito de personas, mercancías y vehículos entre Costa Rica y Nicaragua.\nLa Ruta Nacional 35 se conecta con la Ruta Nacional 32 a través del \"Tapón de Chilamate\", que es la vía principal de entrada y salida de productos de Nicaragua a través de puertos en el Caribe costarricense. También es la ruta turística que une el tránsito de visitantes entre la zona norte y la región del Caribe. Por lo tanto, esta ruta tiene un papel fundamental en el desarrollo económico y turístico de la región, y es un importante punto de conexión para los países de la región centroamericana.",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 3,
            "y_angle": 22,
            "distance": 7
          },
          "title": " ",
          "title_en": " ",
          "title_es": " ",
          "sound_id": null,
          "image_id": "ruta-frontera-0001-panorama-panorama-panorama-11zon",
          "icon_id": "informationtour",
          "video_url": null
        }
      ],
      "trivias": [],
      "description_en": "",
      "description_es": "",
      "name_es": "Ruta Muelle-Tablillas",
      "name_en": "Ruta Muelle-Tablillas",
      "lines": []
    },
    {
      "default_rotation": {
        "x": "0.0",
        "y": "0.0"
      },
      "id_tour_creator": 614,
      "id": "",
      "order": 9,
      "name": "De viaje por el Humedal Medio Queso",
      "bg_id": "humedales-mq",
      "bg_type": "video",
      "has_info": false,
      "description": "",
      "page_url": "",
      "video_id": "vid-20221108-152754-00-061-1",
      "sound_id": "bote_sobre el agua_s",
      "audio_id": null,
      "waypoints": [
        {
          "id_tour_creator": 869,
          "is_premium": false,
          "use_default": true,
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 4,
            "y_angle": 360,
            "distance": 7
          },
          "scale": "1 1 1",
          "text": "Entrada a Caño Negro",
          "text_es": "Entrada a Caño Negro",
          "text_en": "Entrada a Caño Negro",
          "text_position": "1 1 1",
          "text_scale": "1 1 1",
          "text_color": "#202945",
          "to": 580,
          "rig_rotation": {
            "x": "(0,",
            "y": "0)"
          }
        }
      ],
      "hotspots": [],
      "trivias": [],
      "description_en": "",
      "description_es": "",
      "name_es": "De viaje por el Humedal Medio Queso",
      "name_en": "De viaje por el Humedal Medio Queso",
      "lines": []
    },
    {
      "default_rotation": {
        "x": "0.0",
        "y": "0.0"
      },
      "id_tour_creator": 580,
      "id": "",
      "order": 10,
      "name": "Caño Negro - Entrada",
      "bg_id": "01cn-entrada",
      "bg_type": "img",
      "has_info": false,
      "description": "",
      "page_url": "",
      "video_id": null,
      "sound_id": "bosque_ambiente_s",
      "audio_id": "loschiles-cnentrada",
      "waypoints": [
        {
          "id_tour_creator": 827,
          "is_premium": false,
          "use_default": true,
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 2,
            "y_angle": -5,
            "distance": 7
          },
          "scale": "1 1 1",
          "text": "Caño Negro - Instalaciones",
          "text_es": "Caño Negro - Instalaciones",
          "text_en": "Caño Negro - Instalaciones",
          "text_position": "1 1 1",
          "text_scale": "1 1 1",
          "text_color": "#202945",
          "to": 581,
          "rig_rotation": {
            "x": "(0,",
            "y": "0)"
          }
        }
      ],
      "hotspots": [
        {
          "id_tour_creator": 485,
          "has_info": false,
          "info": "El Refugio Nacional de Vida Silvestre Mixto Caño Negro es un área silvestre de gran atractivo, sitio RAMSAR internacional, conocido por sus humedales y su diversidad de vida silvestre. Las lagunas Caño Negro, San Sebastián, Mónico, son el mayor atractivo de la reserva, y es hogar de una amplia variedad de aves estacionales y migratorias, así como reptiles, anfibios, mamíferos, como monos, venados, jaguares, etc. También se pueden encontrar más de 40 especies de peces y pantanos en toda la reserva.",
          "info_es": "El Refugio Nacional de Vida Silvestre Mixto Caño Negro es un área silvestre de gran atractivo, sitio RAMSAR internacional, conocido por sus humedales y su diversidad de vida silvestre. Las lagunas Caño Negro, San Sebastián, Mónico, son el mayor atractivo de la reserva, y es hogar de una amplia variedad de aves estacionales y migratorias, así como reptiles, anfibios, mamíferos, como monos, venados, jaguares, etc. También se pueden encontrar más de 40 especies de peces y pantanos en toda la reserva.",
          "info_en": "El Refugio Nacional de Vida Silvestre Mixto Caño Negro es un área silvestre de gran atractivo, sitio RAMSAR internacional, conocido por sus humedales y su diversidad de vida silvestre. Las lagunas Caño Negro, San Sebastián, Mónico, son el mayor atractivo de la reserva, y es hogar de una amplia variedad de aves estacionales y migratorias, así como reptiles, anfibios, mamíferos, como monos, venados, jaguares, etc. También se pueden encontrar más de 40 especies de peces y pantanos en toda la reserva.",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": -3,
            "y_angle": 29,
            "distance": 7
          },
          "title": "  ",
          "title_en": "  ",
          "title_es": "  ",
          "sound_id": null,
          "image_id": "01cn-entrada",
          "icon_id": "informationtour",
          "video_url": null
        }
      ],
      "trivias": [],
      "description_en": "",
      "description_es": "",
      "name_es": "Caño Negro - Entrada",
      "name_en": "Caño Negro - Entrada",
      "lines": []
    },
    {
      "default_rotation": {
        "x": "0.0",
        "y": "0.0"
      },
      "id_tour_creator": 587,
      "id": "",
      "order": 16,
      "name": "Caño Negro Aerea 4",
      "bg_id": "04-cn-panorama",
      "bg_type": "img",
      "has_info": false,
      "description": "",
      "page_url": "",
      "video_id": null,
      "sound_id": "viento_1_s",
      "audio_id": null,
      "waypoints": [
        {
          "id_tour_creator": 893,
          "is_premium": false,
          "use_default": true,
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 0,
            "y_angle": 0,
            "distance": 7
          },
          "scale": "1 1 1",
          "text": "Regresar",
          "text_es": "Regresar",
          "text_en": "Regresar",
          "text_position": "1 1 1",
          "text_scale": "1 1 1",
          "text_color": "#202945",
          "to": 574,
          "rig_rotation": {
            "x": "(0,",
            "y": "0)"
          }
        }
      ],
      "hotspots": [],
      "trivias": [],
      "description_en": "",
      "description_es": "",
      "name_es": "Caño Negro Aerea 4",
      "name_en": "Caño Negro Aerea 4",
      "lines": []
    },
    {
      "default_rotation": {
        "x": "0.0",
        "y": "0.0"
      },
      "id_tour_creator": 581,
      "id": "",
      "order": 11,
      "name": "Caño Negro - Instalaciones",
      "bg_id": "002instalaciones-cn",
      "bg_type": "img",
      "has_info": false,
      "description": "",
      "page_url": "",
      "video_id": null,
      "sound_id": "bosque_ambiente_s",
      "audio_id": "loschiles-instalaciones",
      "waypoints": [
        {
          "id_tour_creator": 825,
          "is_premium": false,
          "use_default": true,
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": -2,
            "y_angle": 2,
            "distance": 7
          },
          "scale": "1 1 1",
          "text": "Caño Negro - Mirador",
          "text_es": "Caño Negro - Mirador",
          "text_en": "Caño Negro - Mirador",
          "text_position": "1 1 1",
          "text_scale": "1 1 1",
          "text_color": "#202945",
          "to": 582,
          "rig_rotation": {
            "x": "(0,",
            "y": "0)"
          }
        }
      ],
      "hotspots": [
        {
          "id_tour_creator": 486,
          "has_info": false,
          "info": "El Refugio Nacional de Vida Silvestre Caño Negro, es un área de tipo mixto, que combina terreno estatal y territorio privado. Según un estudio de tenencia de la tierra de 2009 por el INBio, el 44% de la superficie del refugio (4.427 hectáreas) es propiedad privada, mientras que el 56% restante es propiedad del Estado, principalmente formado por espejos de agua. El territorio que abarca supera las 10.000 hectáreas, con otra cantidad similar, como área de amortiguamiento.",
          "info_es": "El Refugio Nacional de Vida Silvestre Caño Negro, es un área de tipo mixto, que combina terreno estatal y territorio privado. Según un estudio de tenencia de la tierra de 2009 por el INBio, el 44% de la superficie del refugio (4.427 hectáreas) es propiedad privada, mientras que el 56% restante es propiedad del Estado, principalmente formado por espejos de agua. El territorio que abarca supera las 10.000 hectáreas, con otra cantidad similar, como área de amortiguamiento.",
          "info_en": "El Refugio Nacional de Vida Silvestre Caño Negro, es un área de tipo mixto, que combina terreno estatal y territorio privado. Según un estudio de tenencia de la tierra de 2009 por el INBio, el 44% de la superficie del refugio (4.427 hectáreas) es propiedad privada, mientras que el 56% restante es propiedad del Estado, principalmente formado por espejos de agua. El territorio que abarca supera las 10.000 hectáreas, con otra cantidad similar, como área de amortiguamiento.",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 4,
            "y_angle": -32,
            "distance": 7
          },
          "title": "  ",
          "title_en": "  ",
          "title_es": "  ",
          "sound_id": null,
          "image_id": "002instalaciones-cn",
          "icon_id": "informationtour",
          "video_url": null
        }
      ],
      "trivias": [],
      "description_en": "",
      "description_es": "",
      "name_es": "Caño Negro - Instalaciones",
      "name_en": "Caño Negro - Instalaciones",
      "lines": []
    },
    {
      "default_rotation": {
        "x": "0.0",
        "y": "0.0"
      },
      "id_tour_creator": 578,
      "id": "",
      "order": 7,
      "name": "Frontera Norte - Aérea",
      "bg_id": "01-frontera-0001-panorama-panorama-panorama-1",
      "bg_type": "img",
      "has_info": false,
      "description": "",
      "page_url": "",
      "video_id": null,
      "sound_id": "viento_1_s",
      "audio_id": null,
      "waypoints": [
        {
          "id_tour_creator": 832,
          "is_premium": false,
          "use_default": true,
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": -2,
            "y_angle": 2,
            "distance": 5
          },
          "scale": "1 1 1",
          "text": "Humedales Medio Queso",
          "text_es": "Humedales Medio Queso",
          "text_en": "Humedales Medio Queso",
          "text_position": "1 1 1",
          "text_scale": "1 1 1",
          "text_color": "#202945",
          "to": 579,
          "rig_rotation": {
            "x": "(0,",
            "y": "0)"
          }
        }
      ],
      "hotspots": [],
      "trivias": [],
      "description_en": "",
      "description_es": "",
      "name_es": "Frontera Norte - Aérea",
      "name_en": "Frontera Norte - Aérea",
      "lines": []
    },
    {
      "default_rotation": {
        "x": "0.0",
        "y": "0.0"
      },
      "id_tour_creator": 575,
      "id": "",
      "order": 1,
      "name": "Muelle",
      "bg_id": "muelle",
      "bg_type": "img",
      "has_info": false,
      "description": "",
      "page_url": "",
      "video_id": null,
      "sound_id": "511220-tannahg-river-and-birds",
      "audio_id": "loschiles-muelle",
      "waypoints": [
        {
          "id_tour_creator": 863,
          "is_premium": false,
          "use_default": true,
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 5,
            "y_angle": -7,
            "distance": 7
          },
          "scale": "1 1 1",
          "text": "Ciudad de Los Chiles",
          "text_es": "Ciudad de Los Chiles",
          "text_en": "Ciudad de Los Chiles",
          "text_position": "1 1 1",
          "text_scale": "1 1 1",
          "text_color": "#202945",
          "to": 612,
          "rig_rotation": {
            "x": "(0,",
            "y": "0)"
          }
        }
      ],
      "hotspots": [
        {
          "id_tour_creator": 435,
          "has_info": false,
          "info": "",
          "info_es": "",
          "info_en": "",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 3,
            "y_angle": 43,
            "distance": 7
          },
          "title": "Embarcación",
          "title_en": "Embarcación",
          "title_es": "Embarcación",
          "sound_id": null,
          "image_id": "dsc-9409",
          "icon_id": null,
          "video_url": null
        },
        {
          "id_tour_creator": 443,
          "has_info": false,
          "info": "",
          "info_es": "",
          "info_en": "",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 0,
            "y_angle": 106,
            "distance": 7
          },
          "title": "Embarcación",
          "title_en": "Embarcación",
          "title_es": "Embarcación",
          "sound_id": null,
          "image_id": "dsc-9424",
          "icon_id": null,
          "video_url": null
        },
        {
          "id_tour_creator": 493,
          "has_info": false,
          "info": "El Muelle de Los Chiles, también conocido como el Área Portuaria, es un lugar de gran valor histórico y cultural en la economía local. A través del Río Frío, los pobladores de Los Chiles se comunicaban con Nicaragua para obtener productos básicos esenciales y conectarse con otras poblaciones como Terrón Colorado, Boca de Arenal y la comunidad de Muelle en San Carlos a través del Río San Juan.\nEl muelle ha sido durante mucho tiempo un punto de encuentro para las familias locales y visitantes durante todo el año. Es un lugar ideal para disfrutar de actividades como natación, camping, pesca, picnics y caminatas diurnas por el sendero de la vereda del río. Además, el Muelle de Los Chiles ofrece condiciones recreativas como canchas de voleibol de playa y básquet, un gimnasio al aire libre y un parque infantil para el disfrute de todos.\nEn resumen, el Muelle de Los Chiles es un sitio único que une la historia, la cultura, la naturaleza y el deporte en un solo lugar, lo que lo convierte en un atractivo turístico para todo tipo de visitantes.",
          "info_es": "El Muelle de Los Chiles, también conocido como el Área Portuaria, es un lugar de gran valor histórico y cultural en la economía local. A través del Río Frío, los pobladores de Los Chiles se comunicaban con Nicaragua para obtener productos básicos esenciales y conectarse con otras poblaciones como Terrón Colorado, Boca de Arenal y la comunidad de Muelle en San Carlos a través del Río San Juan.\nEl muelle ha sido durante mucho tiempo un punto de encuentro para las familias locales y visitantes durante todo el año. Es un lugar ideal para disfrutar de actividades como natación, camping, pesca, picnics y caminatas diurnas por el sendero de la vereda del río. Además, el Muelle de Los Chiles ofrece condiciones recreativas como canchas de voleibol de playa y básquet, un gimnasio al aire libre y un parque infantil para el disfrute de todos.\nEn resumen, el Muelle de Los Chiles es un sitio único que une la historia, la cultura, la naturaleza y el deporte en un solo lugar, lo que lo convierte en un atractivo turístico para todo tipo de visitantes.",
          "info_en": "El Muelle de Los Chiles, también conocido como el Área Portuaria, es un lugar de gran valor histórico y cultural en la economía local. A través del Río Frío, los pobladores de Los Chiles se comunicaban con Nicaragua para obtener productos básicos esenciales y conectarse con otras poblaciones como Terrón Colorado, Boca de Arenal y la comunidad de Muelle en San Carlos a través del Río San Juan.\nEl muelle ha sido durante mucho tiempo un punto de encuentro para las familias locales y visitantes durante todo el año. Es un lugar ideal para disfrutar de actividades como natación, camping, pesca, picnics y caminatas diurnas por el sendero de la vereda del río. Además, el Muelle de Los Chiles ofrece condiciones recreativas como canchas de voleibol de playa y básquet, un gimnasio al aire libre y un parque infantil para el disfrute de todos.\nEn resumen, el Muelle de Los Chiles es un sitio único que une la historia, la cultura, la naturaleza y el deporte en un solo lugar, lo que lo convierte en un atractivo turístico para todo tipo de visitantes.",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 5,
            "y_angle": 17,
            "distance": 7
          },
          "title": "  ",
          "title_en": "  ",
          "title_es": "  ",
          "sound_id": null,
          "image_id": "muelle",
          "icon_id": "informationtour",
          "video_url": null
        }
      ],
      "trivias": [],
      "description_en": "",
      "description_es": "",
      "name_es": "Muelle",
      "name_en": "Muelle",
      "lines": []
    },
    {
      "default_rotation": {
        "x": "0.0",
        "y": "0.0"
      },
      "id_tour_creator": 612,
      "id": "",
      "order": 2,
      "name": "Los Chiles",
      "bg_id": "loschiles-denoche",
      "bg_type": "img",
      "has_info": false,
      "description": "",
      "page_url": "",
      "video_id": null,
      "sound_id": "ambiente_ciudad_s",
      "audio_id": "loschiles-chiles",
      "waypoints": [
        {
          "id_tour_creator": 864,
          "is_premium": false,
          "use_default": true,
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 2,
            "y_angle": -5,
            "distance": 5
          },
          "scale": "1 1 1",
          "text": "Municipalidad",
          "text_es": "Municipalidad",
          "text_en": "Municipalidad",
          "text_position": "1 1 1",
          "text_scale": "1 1 1",
          "text_color": "#202945",
          "to": 611,
          "rig_rotation": {
            "x": "(0,",
            "y": "0)"
          }
        }
      ],
      "hotspots": [
        {
          "id_tour_creator": 479,
          "has_info": false,
          "info": "El Cantón de Los Chiles cuenta con diversos lugares de gran importancia para su población. Uno de ellos es la Municipalidad, que representa al Gobierno Local, y que es responsable de controlar y sellar permisos y otros documentos, necesarios para la salida de embarcaciones y personas por el rio frio actividad esencial para la movilización de visitantes y turistas, y generadora de ingresos a la comunidad.",
          "info_es": "El Cantón de Los Chiles cuenta con diversos lugares de gran importancia para su población. Uno de ellos es la Municipalidad, que representa al Gobierno Local, y que es responsable de controlar y sellar permisos y otros documentos, necesarios para la salida de embarcaciones y personas por el rio frio actividad esencial para la movilización de visitantes y turistas, y generadora de ingresos a la comunidad.",
          "info_en": "El Cantón de Los Chiles cuenta con diversos lugares de gran importancia para su población. Uno de ellos es la Municipalidad, que representa al Gobierno Local, y que es responsable de controlar y sellar permisos y otros documentos, necesarios para la salida de embarcaciones y personas por el rio frio actividad esencial para la movilización de visitantes y turistas, y generadora de ingresos a la comunidad.",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 2,
            "y_angle": -47,
            "distance": 7
          },
          "title": "  ",
          "title_en": "  ",
          "title_es": "  ",
          "sound_id": null,
          "image_id": "loschiles-denoche",
          "icon_id": "informationtour",
          "video_url": null
        },
        {
          "id_tour_creator": 480,
          "has_info": false,
          "info": "El Cantón de Los Chiles cuenta con una variedad de lugares y servicios de gran importancia para su población y visitantes. Uno de ellos es la Municipalidad, que representa al Gobierno Local y es responsable de otorgar permisos y otros documentos necesarios para la salida de embarcaciones y personas por el Río Frío, una actividad esencial para el transporte de visitantes y turistas, y una fuente importante de ingresos para la comunidad.\nAdemás, en el centro de la ciudad se encuentra un moderno hospital que puede atender a los habitantes del cantón y a los turistas que visitan la zona. Este hospital es un elemento clave para garantizar la salud y el bienestar de la comunidad. También hay servicios básicos como un banco estatal, cajeros automáticos, estaciones de gasolina, talleres de mecánica rápida, servicio de grúas, estación eléctrica de carga rápida, supermercados, farmacias, estación de Cruz Roja y de Bomberos.",
          "info_es": "El Cantón de Los Chiles cuenta con una variedad de lugares y servicios de gran importancia para su población y visitantes. Uno de ellos es la Municipalidad, que representa al Gobierno Local y es responsable de otorgar permisos y otros documentos necesarios para la salida de embarcaciones y personas por el Río Frío, una actividad esencial para el transporte de visitantes y turistas, y una fuente importante de ingresos para la comunidad.\nAdemás, en el centro de la ciudad se encuentra un moderno hospital que puede atender a los habitantes del cantón y a los turistas que visitan la zona. Este hospital es un elemento clave para garantizar la salud y el bienestar de la comunidad. También hay servicios básicos como un banco estatal, cajeros automáticos, estaciones de gasolina, talleres de mecánica rápida, servicio de grúas, estación eléctrica de carga rápida, supermercados, farmacias, estación de Cruz Roja y de Bomberos.",
          "info_en": "El Cantón de Los Chiles cuenta con una variedad de lugares y servicios de gran importancia para su población y visitantes. Uno de ellos es la Municipalidad, que representa al Gobierno Local y es responsable de otorgar permisos y otros documentos necesarios para la salida de embarcaciones y personas por el Río Frío, una actividad esencial para el transporte de visitantes y turistas, y una fuente importante de ingresos para la comunidad.\nAdemás, en el centro de la ciudad se encuentra un moderno hospital que puede atender a los habitantes del cantón y a los turistas que visitan la zona. Este hospital es un elemento clave para garantizar la salud y el bienestar de la comunidad. También hay servicios básicos como un banco estatal, cajeros automáticos, estaciones de gasolina, talleres de mecánica rápida, servicio de grúas, estación eléctrica de carga rápida, supermercados, farmacias, estación de Cruz Roja y de Bomberos.",
          "position": {
            "origin": [
              0,
              1.6,
              0
            ],
            "x_angle": 14,
            "y_angle": 28,
            "distance": 7
          },
          "title": " ",
          "title_en": " ",
          "title_es": " ",
          "sound_id": null,
          "image_id": "loschiles-denoche",
          "icon_id": "informationtour",
          "video_url": null
        }
      ],
      "trivias": [],
      "description_en": "",
      "description_es": "",
      "name_es": "Los Chiles",
      "name_en": "Los Chiles",
      "lines": []
    }
  ],
  "assets": [
    {
      "id_tour_creator": 347,
      "img": [
        {
          "id": "dsc-3776-panorama-panoramafinal",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/DSC_3776_Panorama_PanoramaFinal.jpeg",
          "id_tour_creator": 1696
        },
        {
          "id": "cn-aerea3",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/cn-aerea3.jpeg",
          "id_tour_creator": 1728
        },
        {
          "id": "dsc-3824-panorama-panoramafinal",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/DSC_3824_Panorama_PanoramaFinal.jpeg",
          "id_tour_creator": 1697
        },
        {
          "id": "dsc-3919-panorama-panoramafinal",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/DSC_3919_Panorama_PanoramaFinal.jpeg",
          "id_tour_creator": 1702
        },
        {
          "id": "06-cakho-negro-0001-panorama-panorama-panorama",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/06_Ca%25E0%25B8%2584o_Negro_0001_Panorama_Panorama_Panorama.jpeg",
          "id_tour_creator": 1715
        },
        {
          "id": "muebles-tablillas",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/muebles-tablillas.jpeg",
          "id_tour_creator": 1720
        },
        {
          "id": "cn-instalaciones",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/cn-instalaciones.jpeg",
          "id_tour_creator": 1724
        },
        {
          "id": "cn-aerea4",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/cn-aerea4.jpeg",
          "id_tour_creator": 1729
        },
        {
          "id": "dsc-3788-panorama-panoramafinal",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/DSC_3788_Panorama_PanoramaFinal.jpeg",
          "id_tour_creator": 1698
        },
        {
          "id": "dsc-3944-panorama-panoramafinal",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/DSC_3944_Panorama_PanoramaFinal.jpeg",
          "id_tour_creator": 1703
        },
        {
          "id": "dsc-3846-panorama-panoramafinal",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/DSC_3846_Panorama_PanoramaFinal.jpeg",
          "id_tour_creator": 1699
        },
        {
          "id": "dsc-4025-panorama-panoramafinal",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/DSC_4025_Panorama_PanoramaFinal.jpeg",
          "id_tour_creator": 1704
        },
        {
          "id": "08-cakho-negro-0001-panorama-panorama-panorama",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/08_Ca%25E0%25B8%2584o_Negro_0001_Panorama_Panorama_Panorama.jpeg",
          "id_tour_creator": 1716
        },
        {
          "id": "frontera-norte",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/frontera-norte.jpeg",
          "id_tour_creator": 1721
        },
        {
          "id": "cn-mirador",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/cn-mirador.jpeg",
          "id_tour_creator": 1725
        },
        {
          "id": "01-frontera-0001-panorama-panorama-panorama-1",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/01_Frontera_0001_Panorama_Panorama_Panorama_1.jpeg",
          "id_tour_creator": 1700
        },
        {
          "id": "04-cakho-negro-0001-panorama-panorama-panorama",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/04_Ca%25E0%25B8%2584o_Negro_0001_Panorama_Panorama_Panorama.jpeg",
          "id_tour_creator": 1709
        },
        {
          "id": "01-cakho-negro-0001-panorama-panorama-panorama",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/01_Ca%25E0%25B8%2584o_Negro__0001_Panorama_Panorama_Panorama.jpeg",
          "id_tour_creator": 1713
        },
        {
          "id": "dsc-3858-panorama-panoramafinal",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/DSC_3858_Panorama_PanoramaFinal.jpeg",
          "id_tour_creator": 1717
        },
        {
          "id": "rio-frio",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/rio_frio.jpeg",
          "id_tour_creator": 1718
        },
        {
          "id": "mojon",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/mojon.jpeg",
          "id_tour_creator": 1722
        },
        {
          "id": "cn-aerea",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/cn-aerea.jpeg",
          "id_tour_creator": 1726
        },
        {
          "id": "img-20221108-152530-00-merged-panoramafinal",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/IMG_20221108_152530_00_merged_PanoramaFinal.jpeg",
          "id_tour_creator": 1701
        },
        {
          "id": "04-cakho-negro-0001-panorama-panorama-panorama",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/04_Ca%25E0%25B8%2584o_Negro_0001_Panorama_Panorama_Panorama.jpeg",
          "id_tour_creator": 1710
        },
        {
          "id": "04-10-cakho-negro-0001-panorama-panorama-panorama",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/04-10_Ca%25E0%25B8%2584o_Negro_0001_Panorama_Panorama_Panorama.jpeg",
          "id_tour_creator": 1714
        },
        {
          "id": "muelle",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/muelle.jpeg",
          "id_tour_creator": 1719
        },
        {
          "id": "cn-entrada",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/cn-entrada.jpeg",
          "id_tour_creator": 1723
        },
        {
          "id": "cn-aerea2",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/cn-aerea2.jpeg",
          "id_tour_creator": 1727
        },
        {
          "id": "icono-menu-1",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/Icono_Menu-1.png",
          "id_tour_creator": 1736
        },
        {
          "id": "dsc-0219",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/DSC_0219.jpeg",
          "id_tour_creator": 1739
        },
        {
          "id": "dsc-9394",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/DSC_9394.jpeg",
          "id_tour_creator": 1740
        },
        {
          "id": "dsc-9409",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/DSC_9409.jpeg",
          "id_tour_creator": 1741
        },
        {
          "id": "dsc-9550",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/DSC_9550.jpeg",
          "id_tour_creator": 1742
        },
        {
          "id": "dsc-9475",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/DSC_9475.jpeg",
          "id_tour_creator": 1743
        },
        {
          "id": "dsc-9606",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/DSC_9606.jpeg",
          "id_tour_creator": 1744
        },
        {
          "id": "dsc-0017",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/DSC_0017.jpeg",
          "id_tour_creator": 1745
        },
        {
          "id": "dsc-9659",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/DSC_9659.jpeg",
          "id_tour_creator": 1746
        },
        {
          "id": "dsc-0111",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/DSC_0111.jpeg",
          "id_tour_creator": 1747
        },
        {
          "id": "dsc-9684",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/DSC_9684.jpeg",
          "id_tour_creator": 1748
        },
        {
          "id": "ruta-frontera-0001-panorama-panorama-panorama-11zon",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/Ruta_Frontera_0001_Panorama_Panorama_Panorama_11zon.jpg",
          "id_tour_creator": 1759
        },
        {
          "id": "dsc-3808-panorama-panoramafinal-11zon",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/DSC_3808_Panorama_PanoramaFinal_11zon.jpg",
          "id_tour_creator": 1761
        },
        {
          "id": "dsc-3876-panorama-1-panoramafinal-2-11zon",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/DSC_3876_Panorama_1_PanoramaFinal_2_11zon.jpg",
          "id_tour_creator": 1762
        },
        {
          "id": "dsc-3876-panorama-1-panoramafinal",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/DSC_3876_Panorama_1_PanoramaFinal.jpg",
          "id_tour_creator": 1763
        },
        {
          "id": "dsc-3858-panorama-panoramafinal-1-11zon",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/DSC_3858_Panorama_PanoramaFinal_1_11zon.jpg",
          "id_tour_creator": 1764
        },
        {
          "id": "img-20221108-152334-00-merged-panoramafinal",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/IMG_20221108_152334_00_merged_PanoramaFinal.jpg",
          "id_tour_creator": 1765
        },
        {
          "id": "rio-frio-2",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/rio-frio-2.jpg",
          "id_tour_creator": 1767
        },
        {
          "id": "dsc-9424",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/DSC_9424.jpg",
          "id_tour_creator": 1768
        },
        {
          "id": "riofrio3",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/riofrio3.jpg",
          "id_tour_creator": 1769
        },
        {
          "id": "loschiles-denoche",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/loschiles-denoche.jpg",
          "id_tour_creator": 1770
        },
        {
          "id": "antigua-oficina-limitrofe001",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/antigua_oficina_limitrofe001.jpg",
          "id_tour_creator": 1771
        },
        {
          "id": "ofi-limitrofe2",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/ofi-limitrofe2.jpg",
          "id_tour_creator": 1772
        },
        {
          "id": "frontera02",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/frontera02.jpg",
          "id_tour_creator": 1773
        },
        {
          "id": "humedales-mq",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/humedales-MQ.jpg",
          "id_tour_creator": 1774
        },
        {
          "id": "01cn-entrada",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/01CN-entrada.jpg",
          "id_tour_creator": 1775
        },
        {
          "id": "002instalaciones-cn",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/002instalaciones-CN.jpg",
          "id_tour_creator": 1776
        },
        {
          "id": "la-torre-cn",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/La-torre-CN.jpg",
          "id_tour_creator": 1777
        },
        {
          "id": "01-cn-aerea1",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/01-CN-aerea1.jpg",
          "id_tour_creator": 1778
        },
        {
          "id": "02-cn-aerea",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/02-CN-aerea.jpg",
          "id_tour_creator": 1779
        },
        {
          "id": "pueblo-cn",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/pueblo-CN.jpg",
          "id_tour_creator": 1780
        },
        {
          "id": "04-cn-panorama",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/04-CN_Panorama.jpg",
          "id_tour_creator": 1781
        },
        {
          "id": "informationtour",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/informationTour.png",
          "id_tour_creator": 1822
        },
        {
          "id": "muni-b",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/muni-b.jpeg",
          "id_tour_creator": 1854
        },
        {
          "id": "rutamt",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/rutaMT.jpeg",
          "id_tour_creator": 1855
        },
        {
          "id": "oficinaf",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/oficinaF.jpeg",
          "id_tour_creator": 1856
        },
        {
          "id": "videoicon",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/videoIcon.png",
          "id_tour_creator": 1857
        },
        {
          "id": "dsc-9843",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/DSC_9843.jpg",
          "id_tour_creator": 1858
        },
        {
          "id": "dsc-9887",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/DSC_9887.jpg",
          "id_tour_creator": 1859
        },
        {
          "id": "dsc-0038",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/DSC_0038.jpg",
          "id_tour_creator": 1860
        },
        {
          "id": "dsc-9436",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/DSC_9436.jpg",
          "id_tour_creator": 1861
        },
        {
          "id": "dsc-0051",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/image/DSC_0051.jpg",
          "id_tour_creator": 1862
        }
      ],
      "sound": [
        {
          "id": "rio_1_s",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/rio01_s.mp3",
          "sound_type": "environment",
          "id_tour_creator": 577
        },
        {
          "id": "viento_1_s",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/viento_1_s.mp3",
          "sound_type": "environment",
          "id_tour_creator": 578
        },
        {
          "id": "ambiente_autos_s",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/ambiente_autos_s.mp3",
          "sound_type": "environment",
          "id_tour_creator": 581
        },
        {
          "id": "ambiente_ciudad_s",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/ambiente_ciudad_s.mp3",
          "sound_type": "environment",
          "id_tour_creator": 579
        },
        {
          "id": "bosque_ambiente_s",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/bosque_ambiente_s.mp3",
          "sound_type": "environment",
          "id_tour_creator": 580
        },
        {
          "id": "riofrio-lc",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/rioFrio-LC.mp3",
          "sound_type": "voice",
          "id_tour_creator": 600
        },
        {
          "id": "frontera-lc",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/frontera-LC.mp3",
          "sound_type": "voice",
          "id_tour_creator": 601
        },
        {
          "id": "humedales-lc",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/Humedales-LC.mp3",
          "sound_type": "voice",
          "id_tour_creator": 602
        },
        {
          "id": "cninstalaciones-lc",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/cnInstalaciones-LC.mp3",
          "sound_type": "voice",
          "id_tour_creator": 603
        },
        {
          "id": "cntorre-lc",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/cnTorre-LC.mp3",
          "sound_type": "voice",
          "id_tour_creator": 604
        },
        {
          "id": "cnreserva1-lc",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/cnReserva1-LC.mp3",
          "sound_type": "voice",
          "id_tour_creator": 605
        },
        {
          "id": "cnreserva2-lc",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/cnReserva2-LC.mp3",
          "sound_type": "voice",
          "id_tour_creator": 606
        },
        {
          "id": "rutam-t-lc",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/rutaM_T-LC.mp3",
          "sound_type": "voice",
          "id_tour_creator": 607
        },
        {
          "id": "bote_sobre el agua_s",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/bote_sobre_el_agua_s.mp3",
          "sound_type": "environment",
          "id_tour_creator": 608
        },
        {
          "id": "lc-riofrio",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/lc-riofrio.mp3",
          "sound_type": "voice",
          "id_tour_creator": 615
        },
        {
          "id": "lc-muelle",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/lc-muelle.mp3",
          "sound_type": "voice",
          "id_tour_creator": 616
        },
        {
          "id": "lc-loschiles",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/lc-losChiles.mp3",
          "sound_type": "voice",
          "id_tour_creator": 617
        },
        {
          "id": "lc-muni",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/lc-muni.mp3",
          "sound_type": "voice",
          "id_tour_creator": 618
        },
        {
          "id": "lc-rutaf",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/lc-rutaF.mp3",
          "sound_type": "voice",
          "id_tour_creator": 619
        },
        {
          "id": "lc-frontera",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/lc-frontera.mp3",
          "sound_type": "voice",
          "id_tour_creator": 620
        },
        {
          "id": "ambiente_oficina_s",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/ambiente_oficina_s.mp3",
          "sound_type": "environment",
          "id_tour_creator": 621
        },
        {
          "id": "lc-oficinas",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/lc-oficinas.mp3",
          "sound_type": "voice",
          "id_tour_creator": 622
        },
        {
          "id": "lc-humedales",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/lc-humedales.mp3",
          "sound_type": "voice",
          "id_tour_creator": 623
        },
        {
          "id": "lc-cnentrada",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/lc-cnEntrada.mp3",
          "sound_type": "voice",
          "id_tour_creator": 624
        },
        {
          "id": "lc-cninstalaciones",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/lc-cnInstalaciones.mp3",
          "sound_type": "voice",
          "id_tour_creator": 625
        },
        {
          "id": "lc-cntorre",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/lc-cnTorre.mp3",
          "sound_type": "voice",
          "id_tour_creator": 626
        },
        {
          "id": "lc-cnreserva1",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/lc-cnreserva1.mp3",
          "sound_type": "voice",
          "id_tour_creator": 627
        },
        {
          "id": "lc-cnreserva2",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/lc-cnreserva2.mp3",
          "sound_type": "voice",
          "id_tour_creator": 628
        },
        {
          "id": "loschiles-riof",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/LosChiles-riof.mp3",
          "sound_type": "voice",
          "id_tour_creator": 652
        },
        {
          "id": "loschiles-muelle",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/LosChiles-Muelle.mp3",
          "sound_type": "voice",
          "id_tour_creator": 653
        },
        {
          "id": "loschiles-chiles",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/LosChiles-Chiles.mp3",
          "sound_type": "voice",
          "id_tour_creator": 654
        },
        {
          "id": "loschiles-municipalidad",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/LosChiles-Municipalidad.mp3",
          "sound_type": "voice",
          "id_tour_creator": 655
        },
        {
          "id": "loschiles-rutas",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/LosChiles-Rutas.mp3",
          "sound_type": "voice",
          "id_tour_creator": 656
        },
        {
          "id": "loschiles-frontera",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/LosChiles-Frontera.mp3",
          "sound_type": "voice",
          "id_tour_creator": 657
        },
        {
          "id": "loschiles-oficinas",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/LosChiles-Oficinas.mp3",
          "sound_type": "voice",
          "id_tour_creator": 658
        },
        {
          "id": "loschiles-humedales",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/LosChiles-Humedales.mp3",
          "sound_type": "voice",
          "id_tour_creator": 659
        },
        {
          "id": "loschiles-cnentrada",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/LosChiles-CNEntrada.mp3",
          "sound_type": "voice",
          "id_tour_creator": 660
        },
        {
          "id": "loschiles-instalaciones",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/LosChiles-Instalaciones.mp3",
          "sound_type": "voice",
          "id_tour_creator": 661
        },
        {
          "id": "loschiles-torre",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/LosChiles-Torre.mp3",
          "sound_type": "voice",
          "id_tour_creator": 662
        },
        {
          "id": "loschiles-cn1",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/LosChiles-CN1.mp3",
          "sound_type": "voice",
          "id_tour_creator": 663
        },
        {
          "id": "loschiles-cn2",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/LosChiles-CN2.mp3",
          "sound_type": "voice",
          "id_tour_creator": 664
        },
        {
          "id": "511220-tannahg-river-and-birds",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/511220__tannahg__river-and-birds.m4a",
          "sound_type": "voice",
          "id_tour_creator": 694
        },
        {
          "id": "new-zonaportuaria",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/new-zonaPortuaria.mp3",
          "sound_type": "voice",
          "id_tour_creator": 709
        },
        {
          "id": "new-rutamt",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/new-RutaMT.mp3",
          "sound_type": "voice",
          "id_tour_creator": 710
        },
        {
          "id": "24539914-1681501971",
          "src": "https://rutaturisticanortenorte.go.cr/experience/norte-loschiles/sound/24539914_1681501971.mp3",
          "sound_type": "voice",
          "id_tour_creator": 716
        }
      ],
      "video": [
        {
          "id": "vid-20221108-152708-00-060-1",
          "src": "https://d1f2porn8aqwt0.cloudfront.net/media/experience/norte-loschiles/video/VID_20221108_152708_00_060_1.mp4",
          "id_tour_creator": 36
        },
        {
          "id": "vid-20221108-152754-00-061-1",
          "src": "https://d1f2porn8aqwt0.cloudfront.net/media/experience/norte-loschiles/video/VID_20221108_152754_00_061_1.mp4",
          "id_tour_creator": 37
        }
      ]
    }
  ],
  "live_sessions": [],
  "tags": [],
  "description": "",
  "location": "",
  "banner": null,
  "link_google_maps": "",
  "thumbnail": null,
  "link_youtube": null,
  "page_guides": "http://localhost:8000/admin",
  "price": 0
}
